import { removeToken } from "@mnk/frontend/lib/auth";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const Logout = () => {
  const navigate = useNavigate();
  useEffect(() => {
    removeToken();
    navigate("/login");
  }, [navigate]);

  return <></>;
};
